export const phoneNumberRegex = /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/;

export const maskedInputsConfig = {
  ssn: {
    format: '###-##-####',
    mask: '_',
  },
  fein: {
    format: '##-#######',
    mask: '_',
  },
};
